import { useState } from 'react';

import NavMenuItem, { type NavMenuItemProps } from './NavMenuItem';

type NestedMenuItemProps = Pick<
  NavMenuItemProps,
  'label' | 'icon' | 'link' | 'subMenu' | 'minified'
>;

function NestedMenuItem(props: Readonly<NestedMenuItemProps>) {
  const { minified: shouldMinified, ...menu } = props;

  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <NavMenuItem
        {...menu}
        open={isOpen}
        minified={shouldMinified}
        onToggleSubMenu={() => setIsOpen((current) => !current)}
      />
      {menu.subMenu?.map((subMenuItem) => (
        <NavMenuItem
          key={subMenuItem.label as string}
          {...subMenuItem}
          disableActiveHighlight={subMenuItem.link === '/qbank-structures/search-by-keywords'}
          minified={shouldMinified || !isOpen}
          collapsible
        />
      ))}
    </>
  );
}

export type { NestedMenuItemProps };
export default NestedMenuItem;
